import React from 'react';
import { func, string } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import { Col, Row } from '@thd-olt-component-react/grid';
import { usePresentation } from '../../../../context/PresentationProvider';

export const FormFooter = ({ className, onSubmit }) => {
  const { useCondensedLayout } = usePresentation();

  const links = [
    {
      label: 'Terms and Conditions',
      link: 'https://homedepot.ugc.bazaarvoice.com/content/1999aa/termsandconditions.htm'
    },
    {
      label: 'Review Guidelines',
      link: 'https://homedepot.ugc.bazaarvoice.com/content/1999aa/guidelines.htm'
    }
  ];

  return (
    <Row className={className}>
      {!useCondensedLayout
        && (
          <Col xs="10">
            <div className="write-review-content__footer__links">
              {links.map((footer) => (
                <a
                  key={footer.label}
                  href={footer.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {footer.label}
                </a>
              ))}
            </div>
          </Col>
        )}
      <Col xs="2" className="write-review-content__submit">
        <Button onClick={onSubmit}>Submit</Button>
      </Col>
    </Row>
  );
};

FormFooter.displayName = 'RatingsAndReviewsFormFooter';

FormFooter.propTypes = {
  className: string,
  onSubmit: func.isRequired
};

FormFooter.defaultProps = {
  className: null
};
